module.exports = __webpack_public_path__ + "img/Menu-14.c5878166.webp";